import { createDrawingObject, replaceLastPoint } from "../shared";
import { toOverlayPrimitive } from "../overlayPrimitiveAdapter";
import { hitTestOverlayPrimitive, renderOverlayPrimitiveToCanvas } from "@vninvestcharts/engine-core";
function renderCrossLine(ctx, drawing, scales, options) {
    const primitive = toOverlayPrimitive(drawing, scales, {
        chartWidth: options.chartWidth,
        chartHeight: options.chartHeight,
    });
    if (primitive) {
        renderOverlayPrimitiveToCanvas(ctx, primitive, options);
    }
}
function hitTestCrossLine(drawing, point, scales, tolerance) {
    const primitive = toOverlayPrimitive(drawing, scales);
    if (!primitive)
        return false;
    return hitTestOverlayPrimitive(primitive, point.pixelX, point.pixelY, { tolerance, chartWidth: 800, chartHeight: 600 });
}
const CrossLine = {
    name: "crossLine",
    createDraft: (startPoint) => createDrawingObject("crossLine", [startPoint], {
        style: { stroke: "#FFFFFF", strokeWidth: 1, opacity: 0.5 },
    }),
    updateDraft: (draft, nextPoint) => replaceLastPoint(draft, nextPoint),
    render: () => undefined,
    hitTest: hitTestCrossLine,
};
export default CrossLine;
